import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AppLoader from "../component/AppLoader";
import { PaginationComponent } from "../component/PaginationComponent"
import Actions from "../Redux/action";
import { getHostelSpecialAccessListSelector, getHostelSpecialAccessCountSelector, getHostelSpecialAccessListLoadingSelector } from "../Redux/reducer/HostelSpecialAccessReducer";
import nodatafound from '../asset/img/datanotfound_black.png';
import { DeclinePopup } from "../component/DeclinePopup";
import { AddHostelSpecialAccessPopup } from "../component/AddHostelSpecialAccess";
import moment from "moment";
import AppDatePicker from "../component/AppDatePicker";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import { getHostelListSelectSelector } from "../Redux/reducer/HostelReducer";
import ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

export const HostelSpecialAccess = () => {
    const EXCEL_EXTENSION = '.xlsx'
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const totalCount = useSelector(getHostelSpecialAccessCountSelector);
    const loading = useSelector(getHostelSpecialAccessListLoadingSelector);
    const hostelSpecialAccesslist = useSelector(getHostelSpecialAccessListSelector);
    const hostelList = useSelector(getHostelListSelectSelector);
    
    const [pageNumber, setPageNumber] = useState(1);
    const [popupData, setPopupData] = useState();
    const [popup, setPopup] = useState(false);
    const dispatch = useDispatch();
    const [itemObj, setItemObj] = useState('');
    const [isOpenDeclineModal, setOpenDeclineModal] = useState(false);
    

    const defaultTimeState = {
        start_time: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
        end_time: moment()
    };
    const [selectedDate, setSelectedDate] = useState('');
    const [formDetails, setFormDetails] = useState({ ...defaultTimeState });
    const [err, setErr] = useState({});
    const [isFiltered, setIsFiltered] = useState(false);
     const [exportLoading, setExportLoading] = useState(false); 

    const getHostelSpecialAccessList = useCallback(() => {
        let params = {
            page: pageNumber,
        }
        
        // Only add filters if we're in filtered mode
        if (isFiltered) {
            if (selectedDate) {
                params.date = moment(selectedDate).format('YYYY-MM-DD');
            }
            
            if (formDetails?.hostel_id) {
                params.hostel_id = formDetails.hostel_id;
            }
            
            if (formDetails?.start_time) {
                params.start_time = moment(formDetails.start_time).format('HH:mm:ss');
            }
            
            if (formDetails?.end_time) {
                params.end_time = moment(formDetails.end_time).format('HH:mm:ss');
            }
        }
        
        dispatch(Actions.hostelSpecialAccessList(params));
    }, [dispatch, pageNumber, isFiltered]);

    useEffect(() => {
        getHostelSpecialAccessList();
    }, [getHostelSpecialAccessList]);

    const onChangeHandle = (pageNumber) => {
        setPageNumber(pageNumber);
    }

    const deleteHostelSpecialAccess = () => {
        const callback = (response) => {
            if (response?.status_code === 0) {
                onCloseModel();
                toast.success("Hostel Special Access successfully deleted");
                getHostelSpecialAccessList();
                if (hostelSpecialAccesslist?.length === 1) {
                    setPageNumber(pageNumber - 1);
                } else {
                    setPageNumber(pageNumber);
                }
            } else {
                toast.error(response?.message);
            }
        }
        let params = {
            id: itemObj?.id
        }
        dispatch(Actions.hostelSpecialAccessDelete(params, callback));
    }
    
    const onClosePopUp = () => {
        setPopupData('');
        setPopup(false);
    }
    
    const onCloseModel = () => {
        setItemObj('');
        setOpenDeclineModal(false);
    };
    
    const handleClick = (item) => {
        setItemObj(item);
        setOpenDeclineModal(true);
    };

    // Filter functions
    const handleHostelSelect = (selected) => {
        setFormDetails({ ...formDetails, 'hostel_id': parseInt(selected) });
        setErr({ ...err, "hostel_id": "" });
    };

    const getDefaultTimesForDate = (date) => {
        if (!date) return defaultTimeState;
        const isToday = moment(date).isSame(moment(), 'day');
        return {
            start_time: moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
            end_time: isToday ? moment() : moment(date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
        };
    };
    const handleDateSelect = (selected) => {
        setSelectedDate(selected);
        setFormDetails((prev) => ({ ...prev, ...getDefaultTimesForDate(selected) }));
        setErr({ ...err, "date": "" });
    };

    const handleTimeChange = (value, time) => {
        if (value) {
            setFormDetails({ ...formDetails, [time]: value });
        }
    };

    const disabledEndMinutes = (selectedHour) => {
        const startMinute = formDetails?.start_time ? moment(formDetails.start_time).minute() : 0;
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        if (selectedHour === startHour) {
            let minutes = [];
            for (let i = 0; i < startMinute; i++) {
                minutes.push(i);
            }
            return minutes;
        }
        return [];
    };

    const disabledEndHours = () => {
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        let hours = [];
        for (let i = 0; i < startHour; i++) {
            hours.push(i);
        }
        return hours;
    };

    const applyFilters = () => {
        if (!formDetails?.hostel_id) {
            setErr({ "hostel_id": "Please select the hostel" });
        } else if (!selectedDate) {
            setErr({ "date": "Please select the date" });
        } else if (!formDetails?.start_time) {
            setErr({ "start_time": "Please select the Start Time" });
        } else if (!formDetails?.end_time) {
            setErr({ "end_time": "Please select the End Time" });
        } else {
            setIsFiltered(true);
            setPageNumber(1);
            setErr({});
        }
    };

    const clearFilters = () => {
        setSelectedDate("");
        setFormDetails({
            hostel_id: '',
            ...defaultTimeState
        });
        setErr({});
        setIsFiltered(false);
        setPageNumber(1);
    };

    const getHostelName = () => hostelList?.find((h) => h?.id == formDetails?.hostel_id)?.name || 'Hostel';
    const safeFormatDate = (val, formatStr, fallback = '-') => {
        if (val == null || val === '') return fallback;
        const m = moment(val);
        return m.isValid() ? m.format(formatStr) : fallback;
    };
    const getFilterSummaryText = () => {
        const parts = [];
        if (selectedDate) parts.push(`Date: ${safeFormatDate(selectedDate, 'DD-MM-YYYY')}`);
        if (formDetails?.start_time != null && formDetails?.end_time != null)
            parts.push(`Time: ${safeFormatDate(formDetails.start_time, 'HH:mm')} - ${safeFormatDate(formDetails.end_time, 'HH:mm')}`);
        return parts.length ? parts.join(' | ') : 'All';
    };

    const handleDownload = () => {
        const callback = async (response) => {
            if (!response?.results?.length) {
                toast.error("Something went wrong");
                setExportLoading(false);
                return;
            }
            const hostelName = getHostelName();
            const filterSummary = getFilterSummaryText();
            const dateStr = safeFormatDate(selectedDate, 'DD-MM-YYYY', moment().format('DD-MM-YYYY'));
            const headers = ['S.No', 'Name', 'Member ID', 'Hostel Name', 'Start Time', 'End Time', 'Entry Type'];
            const rows = response.results.map((item, idx) => ({
                'S.No': idx + 1,
                'Name': item?.name,
                'Member ID': item?.member_id,
                'Hostel Name': item?.hostel,
                'Start Time': moment(item?.start_time).isValid() ? moment(item.start_time).format('DD-MM-YYYY HH:mm:ss') : '',
                'End Time': moment(item?.end_time).isValid() ? moment(item.end_time).format('DD-MM-YYYY HH:mm:ss') : '',
                'Entry Type': item?.entry_type ?? '',
            }));
            const colCount = headers.length;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('data', { views: [{ rightToLeft: false }] });
            worksheet.mergeCells(1, 1, 1, colCount);
            worksheet.getCell(1, 1).value = hostelName;
            worksheet.getCell(1, 1).font = { bold: true };
            worksheet.getCell(1, 1).alignment = { horizontal: 'center', vertical: 'middle' };
            worksheet.mergeCells(2, 1, 2, colCount);
            worksheet.getCell(2, 1).value = filterSummary;
            worksheet.getCell(2, 1).font = { bold: true };
            worksheet.getCell(2, 1).alignment = { horizontal: 'center', vertical: 'middle' };
            const headerRow = worksheet.addRow(headers);
            headerRow.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            rows.forEach((row) => worksheet.addRow(headers.map((h) => row[h] ?? '')));
            worksheet.columns = headers.map(() => ({ width: 16 }));
            const buffer = await workbook.xlsx.writeBuffer();
            const fileName = `hostelspeciall access_${dateStr}${EXCEL_EXTENSION}`;
            FileSaver.saveAs(new Blob([buffer], { type: EXCEL_TYPE }), fileName);
            toast.success("Downloaded Successfully");
            setExportLoading(false);
        };
        const params = {
            hostel_id: formDetails?.hostel_id,
            page: 1,
            page_size: 10000,
            ...(formDetails?.start_time ? { start_time: moment(formDetails.start_time).format('HH:mm:ss') } : {}),
            ...(formDetails?.end_time ? { end_time: moment(formDetails.end_time).format('HH:mm:ss') } : {}),
            ...(selectedDate ? { date: moment(selectedDate).format('YYYY-MM-DD') } : {}),
        };
        setExportLoading(true);
        dispatch(Actions.hostelSpecialAccessList(params, callback));
    };

    return (
        <>
            {(loading || exportLoading) && <AppLoader />}
            
            <div className="ecommerce-widget">
                <h5 className="card-header">Hostel Special Access</h5>
                
                {/* Filters Section */}
                <div className="card border-3 border-top border-top-primary">
                    <div className="row m-0">
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label htmlFor="exampleInputEmail1" className="form-label">Hostel</label>
                            <select 
                                value={formDetails?.hostel_id} 
                                onChange={(e) => handleHostelSelect(e?.target?.value)}
                                className="form-select"
                            >
                                <option value='' hidden>Select Hostel</option>
                                {Array.isArray(hostelList) && hostelList?.map((o) => (
                                    <option key={o?.id} value={o?.id}>{o?.name}</option>
                                ))}
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.hostel_id}</p>
                        </div>
                        
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Date</label>
                            <div className="input-group mb">
                                <AppDatePicker
                                    disabled={!formDetails?.hostel_id}
                                    selected={selectedDate && moment(selectedDate).isValid() ? moment(selectedDate).toDate() : null}
                                    placeholder="Date"
                                    maxDate={new Date()}
                                    onChange={(date) => {
                                        handleDateSelect(date)
                                    }}
                                    notValidTime={true}
                                    id='FormDatePicker'
                                />
                            </div>
                            <p style={{ 'color': 'red' }}>{err?.date}</p>
                        </div>
                        
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Start Time</label>
                            <div className="input-group mb">
                                <TimePicker 
                                    showSecond={false} 
                                    format={'HH:mm'} 
                                    disabled={!selectedDate} 
                                    onChange={(v) => handleTimeChange(v, "start_time")} 
                                    value={formDetails?.start_time ?? defaultTimeState.start_time} 
                                    disableClock={true} 
                                    className="form-control cursor-pointer" 
                                />
                            </div>
                            <p style={{ 'color': 'red' }}>{err?.start_time}</p>
                        </div>
                        
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">End Time</label>
                            <div className="input-group mb">
                                <TimePicker 
                                    showSecond={false} 
                                    format={'HH:mm'} 
                                    disabled={!selectedDate} 
                                    clearIcon={false} 
                                    onChange={(v) => handleTimeChange(v, "end_time")} 
                                    value={formDetails?.end_time ?? defaultTimeState.end_time} 
                                    disableClock={true} 
                                    className="form-control dateInput cursor-pointer" 
                                    disabledHours={disabledEndHours}
                                    disabledMinutes={disabledEndMinutes} 
                                />
                            </div>
                            <p style={{ 'color': 'red' }}>{err?.end_time}</p>
                        </div>
                        
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate1 d-flex align-items-end">
                            <div className="d-flex gap-2">
                                {!isFiltered ? (
                                    <button type="button" className="btn btn-primary" onClick={applyFilters}>
                                        View
                                    </button>
                                ) : null}
                                
                                {(isFiltered || selectedDate || formDetails?.hostel_id) && (
                                    <button className="btn btn-primary" onClick={clearFilters}>
                                        Clear
                                    </button>
                                )}
                                
                                <button type="button" className="btn btn-primary" onClick={() => setPopup(true)}>
                                    Add Special Access
                                </button>
                                <button type="button" className="btn btn-primary" onClick={() => handleDownload()}>
                                    Export
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {isFiltered && (
                    <div className="card mb-3 mt-3 p-3 bg-light rounded">
                        <h6 className="mb-2 fw-bold">Selected filter</h6>
                        <div className="d-flex flex-wrap gap-3 small">
                            <span><strong>Hostel:</strong> {getHostelName()}</span>
                            <span><strong>Date:</strong> {safeFormatDate(selectedDate, 'DD-MM-YYYY')}</span>
                            <span><strong>Time:</strong> {formDetails?.start_time != null && formDetails?.end_time != null ? `${safeFormatDate(formDetails.start_time, 'HH:mm')} - ${safeFormatDate(formDetails.end_time, 'HH:mm')}` : '-'}</span>
                        </div>
                    </div>
                )}
                
                {/* Data Table Section */}
                <div className="card">
                    <div className="card-body p-0">
                        {hostelSpecialAccesslist && hostelSpecialAccesslist.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table onboardTable">
                                    <thead className="bg-light">
                                        <tr className="border-0">
                                            <th className="border-0">S.No</th>
                                            <th className="border-0">Name</th>
                                            <th className="border-0">Hostel Name</th>
                                            <th className="border-0">Start Time</th>
                                            <th className="border-0">End Time</th>
                                            <th className="border-0">Entry Type</th>
                                            <th className="border-0">Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {hostelSpecialAccesslist?.map((item, index) => (
                                            <tr key={item?.id}>
                                                <td>{((pageNumber - 1) * 10) + (index + 1)}</td>
                                                <td>{item?.name} ({item?.member_id})</td>
                                                <td>{item?.hostel}</td>
                                                <td>{moment(item?.start_time).format("DD-MM-YYYY HH:mm:ss")}</td>
                                                <td>{moment(item?.end_time).format("DD-MM-YYYY HH:mm:ss")}</td>
                                                <td>{item?.entry_type}</td>
                                                <td>
                                                    <button type="button" className="btn btn-primary" onClick={() => handleClick(item)}>
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="7">
                                                <PaginationComponent 
                                                    onChangeHandle={onChangeHandle} 
                                                    pageCount={totalCount} 
                                                    pageNumber={pageNumber} 
                                                    setpage={setPageNumber} 
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="d-flex justify-content-center mt-5">
                                <div className="NodataFound">
                                    <h3>No Data Found</h3>
                                </div>
                                <div className="NodataImage">
                                    <img src={nodatafound} alt="No Data Found" className="NoData" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            
            {popup && (
                <AddHostelSpecialAccessPopup 
                    pageNumber={pageNumber} 
                    onClose={() => onClosePopUp(false)} 
                    data={popupData} 
                />
            )}
            
            {isOpenDeclineModal && (
                <DeclinePopup
                    title={`Are you sure you want to delete ${itemObj?.hostel} special access?`}
                    onClose={() => onCloseModel()}
                    onSuccess={() => deleteHostelSpecialAccess()}
                />
            )}
        </>
    );
};